import React from 'react';
import gaLogger from 'src/utils/ga-logger';
import { UitkSelect } from 'uitk-react-select';
import { DESTINATION_GROUPS, IDestinationGroup } from 'src/components/common/SearchWizard/shareduiwizard/cruise/data';

interface SelectDropdownProps {
  id: string;
  label: string;
  name: string;
  exClass?: string;
  invalid?: string;
  value?: string;
  hasVisibleLabel?: boolean;
  error: string;
  onChangeEvent?: (evt: any) => any;
  gaTracking:
    | {
        eventCategory: string;
        eventAction: string;
        eventLabel: string;
      }
    | undefined;
  initialOption?: {
    label: string;
    value: string;
  };
}

const SelectDropdown: React.FC<SelectDropdownProps> = (props) => {
  const { name, label, onChangeEvent, gaTracking, value, error } = props;

  const onChange = (e) => {
    if (onChangeEvent) {
      onChangeEvent(e);
    }
    if (gaTracking) {
      const { eventCategory, eventAction, eventLabel } = gaTracking;
      gaLogger.logGa(eventCategory, eventAction, eventLabel);
    }
  };

  return (
    <UitkSelect
      id="cruise-destination"
      name={name}
      label={label}
      aria-label={label}
      onChange={onChange}
      value={value}
      data-testid="cruise-destination"
      invalid={error}
    >
      <option data-testid="destination-placeholder-option" value="">
        {'Select destination'}
      </option>

      {Object.keys(DESTINATION_GROUPS).map((groupKey) => {
        const group: IDestinationGroup = DESTINATION_GROUPS[groupKey];

        return (
          <optgroup key={groupKey} label={group.locKey}>
            {group.items.map(({ value, locKey }) => (
              <option key={value} value={value}>
                {locKey}
              </option>
            ))}
          </optgroup>
        );
      })}
    </UitkSelect>
  );
};

export { SelectDropdownProps, SelectDropdown };
